import { render } from "./Ebook.vue?vue&type=template&id=1a0db262&scoped=true"
import script from "./Ebook.vue?vue&type=script&lang=js"
export * from "./Ebook.vue?vue&type=script&lang=js"

import "./Ebook.vue?vue&type=style&index=0&id=1a0db262&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0db262"]])

export default __exports__